import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import PropTypes from 'prop-types';


const KennenlernenPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.KennenlernenPageData.edges[0]
  return (
    <Layout>
      <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
      <section className="solutions sub kennenlernen about">

        <section className="headliner starfield t1 b1">
          <div className="container">
            <div className="column">
              <h1>Lernen Sie <strong>presono</strong> kennen!</h1>
              <p>Registrieren Sie sich für einen unserer Vorstellungstermine via Webinar</p>
            </div>
          </div>
        </section>
        <section className="kennen-text">
          <div className="container">
            <div className="columns">
              <div className="column is-full logos2">
                <div className="columns inner">
                  <div className="column is-3">
                    <img src={withPrefix('/img/kennenlernen.svg')} alt="kennenlernen" />
                  </div>
                  <div className="column is-9">
                    <h2>Melde dich für unsere nächsten Seminare an!</h2>
                    <p>
                    Sie möchten die Idee hinter presono erklärt bekommen und sehen, was die konkreten Vorteile sind? Entdecken Sie, wie presono Sie unterstützen kann: in allen Präsentationen, im Vertrieb, auf Messen, im Schulungsbereich, … Professionelles Präsentieren, modern und innovativ.
                    Wir stellen Ihnen die Idee sowie die Vorteile von presono vor und zeigen Ihnen ein paar Beispiele, wie und wo presono genutzt wird.
                    </p>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </section>
        <OutboundLink className="button is-rounded features-button" target="_blank" href="https://help.presono.com/hc/de/articles/360004782518-Melde-dich-hier-an-f%C3%BCr-unsere-n%C3%A4chsten-Webinare-">Jetzt anmelden!</OutboundLink>
      </section>
      <Newsletter newsletter={data.frontmatter} locale={locale} />
      <Footer locale={locale} />
    </Layout>
  )
}

export default KennenlernenPage;

KennenlernenPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query KennenlernenPageContent($locale: String) {
    KennenlernenPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_kennenlernen"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          langSwitch
        }
      }
    }
  }
}
`
